import { c as compute_rest_props, s as subscribe } from "./utils.js";
import { c as create_ssr_component, g as getContext, s as spread, a as escape_attribute_value, b as escape_object, d as add_attribute, e as escape, f as createEventDispatcher, v as validate_component } from "./ssr.js";
import { twMerge } from "tailwind-merge";
import { E as ExclamationCircleSolid } from "./ExclamationCircleSolid.js";
import { B as Button } from "./Button.js";
import { R as Radio } from "./Checkbox.js";
import { I as Input } from "./Input.js";
import { S as Select } from "./Select.js";
import { T as Toggle } from "./Toggle.js";
import { M as Modal } from "./Modal2.js";
import "./files.js";
import { g as globalToast } from "./toast2.js";
import "dayjs";
import { M as ModalFooter, a as ModalHeader } from "./ModalHeader.js";
import { F as FileDrop } from "./FileDrop.js";
const ArrowsRepeatCountOutline = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "strokeWidth", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { strokeWidth = ctx.strokeWidth || "2" } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "arrows repeat count outline" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.strokeWidth === void 0 && $$bindings.strokeWidth && strokeWidth !== void 0) $$bindings.strokeWidth(strokeWidth);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="m16 4 3 3H5v3m3 10-3-3h14v-3m-9-2.5 2-1.5v4"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="m16 4 3 3H5v3m3 10-3-3h14v-3m-9-2.5 2-1.5v4"></path></svg>`} `;
});
const UploadSolid = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "upload solid" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path fill-rule="evenodd" d="M12 3a1 1 0 0 1 .78.375l4 5a1 1 0 1 1-1.56 1.25L13 6.85V14a1 1 0 1 1-2 0V6.85L8.78 9.626a1 1 0 1 1-1.56-1.25l4-5A1 1 0 0 1 12 3ZM9 14v-1H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-4v1a3 3 0 1 1-6 0Zm8 2a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H17Z" clip-rule="evenodd"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path fill-rule="evenodd" d="M12 3a1 1 0 0 1 .78.375l4 5a1 1 0 1 1-1.56 1.25L13 6.85V14a1 1 0 1 1-2 0V6.85L8.78 9.626a1 1 0 1 1-1.56-1.25l4-5A1 1 0 0 1 12 3ZM9 14v-1H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-4v1a3 3 0 1 1-6 0Zm8 2a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H17Z" clip-rule="evenodd"></path></svg>`} `;
});
const documentTags = [
  { name: "Foto", value: "picture" },
  { name: "Mitarbeiterfoto", value: "picture-company" },
  { name: "Sedcard", value: "sedcard" },
  { name: "Mitarbeiterausweis", value: "employee-id" },
  { name: "Personalausweis/Reisepass", value: "id-card" },
  { name: "Führerschein", value: "license" },
  { name: "Studiennachweis/Immatrikulationsbescheinigung", value: "student-verification" },
  { name: "Vertragsdokument", value: "contract-document" },
  { name: "Avatar", value: "avatar" },
  { name: "Sonstiges", value: "other" }
];
const tagToString = (tag) => documentTags.find((x) => x.value === tag)?.name || "Sonstiges";
const documentWantsNumber = (tag) => ["employee-id", "id-card", "license", "student-verification"].includes(tag);
const EmployeeUploadModal = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $globalToast, $$unsubscribe_globalToast;
  $$unsubscribe_globalToast = subscribe(globalToast, (value) => $globalToast = value);
  let { open = false } = $$props;
  let { employee } = $$props;
  let { accept = "image/*" } = $$props;
  createEventDispatcher();
  let photo;
  let photoTag = "other";
  let documentNumber = "";
  let photoTags = documentTags.filter((x) => !["contract-document", "avatar"].includes(x.value));
  let overwriteName = true;
  let documentName = "";
  let frontOrBack = "front";
  const photoLoader = (accepted, rejected) => {
    console.log({ accepted, rejected });
    if (rejected.length > 0) {
      $globalToast.timed("Datei nicht zugelassen", 3e3, ExclamationCircleSolid);
    } else {
      photo = accepted[0];
    }
  };
  if ($$props.open === void 0 && $$bindings.open && open !== void 0) $$bindings.open(open);
  if ($$props.employee === void 0 && $$bindings.employee && employee !== void 0) $$bindings.employee(employee);
  if ($$props.accept === void 0 && $$bindings.accept && accept !== void 0) $$bindings.accept(accept);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(Modal, "Modal").$$render(
      $$result,
      { open },
      {
        open: ($$value) => {
          open = $$value;
          $$settled = false;
        }
      },
      {
        footer: () => {
          return `${validate_component(ModalFooter, "ModalFooter").$$render($$result, {}, {}, {
            right: () => {
              return `${validate_component(Button, "Button").$$render($$result, {}, {}, {
                default: () => {
                  return `${validate_component(UploadSolid, "UploadSolid").$$render($$result, { class: "w-4 h-4 me-2" }, {}, {})} Upload`;
                }
              })}`;
            }
          })} `;
        },
        header: () => {
          return `${validate_component(ModalHeader, "ModalHeader").$$render($$result, { title: "Bild hochladen" }, {}, {})}`;
        },
        default: () => {
          return `<h3 class="mt-3 text-xl text-neutral-600" data-svelte-h="svelte-1mpnem8">Upload Image</h3> <form class="flex flex-col gap-3">${validate_component(Select, "Select").$$render(
            $$result,
            {
              type: "text",
              class: "w-full",
              name: "imageTag",
              items: photoTags,
              placeholder: "Image Tag",
              value: photoTag
            },
            {
              value: ($$value) => {
                photoTag = $$value;
                $$settled = false;
              }
            },
            {}
          )} ${documentWantsNumber(photoTag) ? `${validate_component(Input, "Input").$$render(
            $$result,
            {
              type: "text",
              class: "w-full",
              name: "number",
              placeholder: tagToString(photoTag) + "-Nummer",
              value: documentNumber
            },
            {
              value: ($$value) => {
                documentNumber = $$value;
                $$settled = false;
              }
            },
            {
              left: () => {
                return `${validate_component(ArrowsRepeatCountOutline, "ArrowsRepeatCountOutline").$$render($$result, { slot: "left", class: "w-4 h-4" }, {}, {})}`;
              }
            }
          )}` : ``} ${validate_component(Toggle, "Toggle").$$render(
            $$result,
            { checked: overwriteName },
            {
              checked: ($$value) => {
                overwriteName = $$value;
                $$settled = false;
              }
            },
            {
              default: () => {
                return `Dateiname überschreiben`;
              }
            }
          )} ${overwriteName ? `${photoTag === "id-card" || photoTag === "license" ? `<div class="flex gap-3">${validate_component(Radio, "Radio").$$render(
            $$result,
            { value: "front", group: frontOrBack },
            {
              group: ($$value) => {
                frontOrBack = $$value;
                $$settled = false;
              }
            },
            {
              default: () => {
                return `Vorderseite`;
              }
            }
          )} ${validate_component(Radio, "Radio").$$render(
            $$result,
            { value: "back", group: frontOrBack },
            {
              group: ($$value) => {
                frontOrBack = $$value;
                $$settled = false;
              }
            },
            {
              default: () => {
                return `Rückseite`;
              }
            }
          )}</div>` : ``} ${validate_component(Input, "Input").$$render(
            $$result,
            {
              type: "text",
              placeholder: "Dokumentenname",
              value: documentName
            },
            {
              value: ($$value) => {
                documentName = $$value;
                $$settled = false;
              }
            },
            {}
          )}` : ``} ${validate_component(FileDrop, "FileDrop").$$render(
            $$result,
            {
              extract: photoLoader,
              allowedFiles: ["jpg", "jpeg", "png", "pdf", "gif"],
              allowedSize: "6MB"
            },
            {},
            {}
          )} ${photo ? `<div class="flex gap-3 w-full justify-between"><span>${escape(photo.name)}</span></div>` : ``}</form>`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_globalToast();
  return $$rendered;
});
export {
  EmployeeUploadModal as E,
  UploadSolid as U,
  tagToString as t
};
//# sourceMappingURL=EmployeeUploadModal.js.map
